import webAppConfig from "../commons/webApp.config";

//signalr
var connection = $.hubConnection();
connection.url =
    (webAppConfig.baseURL ? webAppConfig.baseURL : "") + "/signalr";
var qhub = connection.createHubProxy("fETIASHub");

var emitConnectionState = function (state) {
    if (window.eventBus) {
        window.eventBus.$emit("signalr.connectionState", state);
    }
};

var currentWorkspaceId = null;
// The teammate chat session currently subscribed to live progress (AITeammateService
// EmitProgress -> "tm:{sessionId}" group). Tracked so it can be rejoined after a reconnect,
// the same way currentWorkspaceId is.
var currentSessionId = null;

var connectHub = async function () {
    var authData = JSON.parse(
        window.localStorage.getItem("ls.authorizationData")
    );

    if (authData) {
        connection.qs = {
            Authorization: authData.access_token,
            connectionData: "[{ name: 'fetiashub' }]"
        };
    }

    emitConnectionState("connecting");
    await connection.start({ transport: 'webSockets' });
    console.log("hub connected. " + moment().format("DD-MM-YYYY HH:mm:ss"));
    emitConnectionState("connected");

    // connection.start().done(function() {
    //     console.log("hub connected. " + moment().format("DD-MM-YYYY HH:mm:ss"));
    //     qhub.invoke('joinWorkspace', workspaceId);
    // });
}

var reconnect = async function () {
    var state = getConnectionState();
    if (state === 'connected' || state === 'connecting' || state === 'reconnecting') {
        try {
            connection.stop();
        } catch (err) {
            console.warn('hub stop failed', err);
        }
    }

    await connectHub();

    if (currentWorkspaceId) {
        try {
            qhub.invoke('joinWorkspace', currentWorkspaceId);
        } catch (err) {
            console.warn('joinWorkspace failed', err);
        }
    }

    if (currentSessionId) {
        try {
            qhub.invoke('joinSession', currentSessionId);
        } catch (err) {
            console.warn('joinSession failed', err);
        }
    }
}

// Subscribe this connection to a teammate chat session's live-progress group. Best-effort:
// progress is a UI nicety, so a failed invoke (e.g. not yet connected) is swallowed — it will
// be rejoined on the next reconnect via currentSessionId.
var joinSession = function (sessionId) {
    currentSessionId = sessionId || null;
    if (!currentSessionId) return;
    try {
        if (getConnectionState() === 'connected') {
            qhub.invoke('joinSession', currentSessionId);
        }
    } catch (err) {
        console.warn('joinSession failed', err);
    }
}

var leaveSession = function (sessionId) {
    var id = sessionId || currentSessionId;
    if (currentSessionId === sessionId) currentSessionId = null;
    if (!id) return;
    try {
        if (getConnectionState() === 'connected') {
            qhub.invoke('leaveSession', id);
        }
    } catch (err) {
        console.warn('leaveSession failed', err);
    }
}

var getConnectionState = function() {
    let status = '';
    console.log(qhub.connection.state)

    switch(qhub.connection.state)
    {
        case $.signalR.connectionState.connecting:
            status = 'connecting';
            break;
            
        case $.signalR.connectionState.connected:
            status = 'connected';
            break;
            
        case $.signalR.connectionState.reconnecting:
            status = 'reconnecting';
            break;
            
        case $.signalR.connectionState.disconnected:
            status = 'disconnected';
            break;
    }

    return status;
}

var setupCommunication = async function (workspaceId) {
    currentWorkspaceId = workspaceId;

    if(getConnectionState() == 'disconnected') {
        await connectHub();
    }

    qhub.invoke('joinWorkspace', workspaceId);
    // If a teammate chat already subscribed before the hub was connected, join its group now.
    if (currentSessionId) qhub.invoke('joinSession', currentSessionId);

    connection.reconnecting(function () {
        console.log(
            "hub reconnecting. " + moment().format("DD-MM-YYYY HH:mm:ss")
        );
        emitConnectionState("reconnecting");
    });

    connection.reconnected(function () {
        console.log(
            "hub reconnected. " + moment().format("DD-MM-YYYY HH:mm:ss")
        );
        emitConnectionState("connected");
    });

    connection.disconnected(function () {
        console.log(
            "hub disconnected. " + moment().format("DD-MM-YYYY HH:mm:ss")
        );
        emitConnectionState("disconnected");

        setTimeout(function () {
            emitConnectionState("connecting");
            connection.start({ transport: 'webSockets' }).done(function () {
                console.log('hub connected. ' + moment().format('DD-MM-YYYY HH:mm:ss'));
                emitConnectionState("connected");
                qhub.invoke('joinWorkspace', workspaceId);
                if (currentSessionId) qhub.invoke('joinSession', currentSessionId);
            });
        }, 10000);
    });

    connection.error(function (err) {
        console.log(
            "HUB ERROR: " + err + ". " + moment().format("DD-MM-YYYY HH:mm:ss")
        );
        if (window.eventBus) {
            window.eventBus.$emit("signalr.error", err);
        }
    });
};

qhub.on("scriptDebug", function (data) {
    console.log(data);
    if (window.eventBus) {
        window.eventBus.$emit("signalr.scriptDebug", data);
    }
});

qhub.on("workspaceChanged", (data) => {
    try {
        const res = JSON.parse(data);
        window.eventBus.$emit("signalr.workspaceChanged", res);
    } catch(err) {
        console.error(err);
    }
});

qhub.on("userChanged", (data) => {
    try {
        const res = JSON.parse(data);
        window.eventBus.$emit("signalr.userChanged", res);
    } catch(err) {
        console.error(err);
    }
});

qhub.on("refreshNotification", function (data) {
    window.eventBus.$emit("refreshNotification");
});

// Selection-cache invalidation (docs/fe-caching-and-formula-performance-design.md §5). On any entry
// write to a module, the server pushes { moduleId, entryId } to the workspace group; the FE drops
// every cached option list sourced from that module. `entryId` is unused for correctness today (we
// drop the whole small list and refetch lazily) but kept for a future surgical-patch optimization.
qhub.on("selectionInvalidated", function (data) {
    try {
        const res = typeof data === "string" ? JSON.parse(data) : data;
        if (window.eventBus) {
            window.eventBus.$emit("signalr.selectionInvalidated", res);
        }
    } catch (err) {
        console.error(err);
    }
});

// Comment create/edit/delete on an entry (FETIAS docs/collaboration-comment-edit-delete-proposal.md
// §9). Content-free: { workspaceId, moduleId, entryId, id, type, op, by, editedOn?, deletedBy? } —
// a history panel open on that entry refetches through the rights-masked History endpoint.
qhub.on("commentChanged", function (data) {
    try {
        const res = typeof data === "string" ? JSON.parse(data) : data;
        if (window.eventBus) {
            window.eventBus.$emit("signalr.commentChanged", res);
        }
    } catch (err) {
        console.error(err);
    }
});

// Mid-turn progress from the AI TeamMate (AITeammateService.EmitProgress). Best-effort —
// the authoritative chat result still arrives in the /api/teammate/chat response; this only
// drives a transient status line. Payload: { sessionId, phase: 'tool'|'tool_done', tool,
// module, activity, entryId } — the client composes the human-readable label from these.
qhub.on("teammateProgress", function (data) {
    try {
        const res = JSON.parse(data);
        window.eventBus.$emit("signalr.teammateProgress", res);
    } catch (err) {
        console.error(err);
    }
});

export default {
    setupCommunication: setupCommunication,
    getConnectionState: getConnectionState,
    reconnect: reconnect,
    joinSession: joinSession,
    leaveSession: leaveSession
}